
    import './styles.scoped.css';
    export default {
  "dropdown": "_dropdown_1hzng_3",
  "awsui-motion-fade-in-dropdown": "_awsui-motion-fade-in-dropdown_1hzng_1",
  "root": "_root_1hzng_25",
  "interior": "_interior_1hzng_36",
  "root-inline": "_root-inline_1hzng_40",
  "stretch": "_stretch_1hzng_43",
  "trigger-inline": "_trigger-inline_1hzng_46",
  "dropdown-drop-up": "_dropdown-drop-up_1hzng_69",
  "with-limited-width": "_with-limited-width_1hzng_73",
  "dropdown-drop-left": "_dropdown-drop-left_1hzng_76",
  "dropdown-drop-right": "_dropdown-drop-right_1hzng_79",
  "occupy-entire-width": "_occupy-entire-width_1hzng_82",
  "hide-upper-border": "_hide-upper-border_1hzng_85",
  "open": "_open_1hzng_91",
  "nowrap": "_nowrap_1hzng_94",
  "extra-margin": "_extra-margin_1hzng_99",
  "ie11-wrapper": "_ie11-wrapper_1hzng_107"
};
  